/**
 * Marketing i18n, bundles are generated by the backend translation job
 * (Settings → Translations) and written to ./bundles/<lang>.json.
 * Lookup is exact-source-string → translation; untranslated strings fall
 * back to English so partially-translated bundles degrade gracefully.
 */
import hu from './bundles/hu.json';
import pl from './bundles/pl.json';
import de from './bundles/de.json';

export const MARKETING_LANGS = ['hu', 'pl', 'de'];
export const LANG_LABELS = { en: 'EN', hu: 'HU', pl: 'PL', de: 'DE' };

const BUNDLES = { hu, pl, de };

export const getDict = (lang) => BUNDLES[lang] || null;
export const tr = (dict, s) => (dict && dict[s]) || s;

// Keys whose values must never be translated (routes, codes, dates).
const SKIP_KEYS = new Set(['slug', 'to', 'url', 'href', 'id', 'keywords',
  'datePublished', 'dateModified', 'readMinutes', 'category']);

export function localizeDeep(obj, dict, keyName) {
  if (!dict) return obj;
  if (typeof obj === 'string') return SKIP_KEYS.has(keyName) ? obj : tr(dict, obj);
  if (Array.isArray(obj)) return obj.map((v) => localizeDeep(v, dict, keyName));
  if (obj && typeof obj === 'object') {
    const out = {};
    for (const [k, v] of Object.entries(obj)) out[k] = localizeDeep(v, dict, k);
    return out;
  }
  return obj;
}

/** Strip a leading language prefix from a pathname → { lang, path } */
export function splitLangPath(pathname) {
  const m = pathname.match(/^\/(hu|pl|de)(\/.*|$)/);
  if (m) return { lang: m[1], path: m[2] || '/' };
  return { lang: 'en', path: pathname };
}

/** Build the equivalent URL of `path` in `lang` (en = no prefix). */
export function langHref(lang, path) {
  const clean = path.startsWith('/') ? path : `/${path}`;
  return lang === 'en' ? clean : `/${lang}${clean === '/' ? '' : clean}`;
}
